import { render, staticRenderFns } from "./TransformQueue.vue?vue&type=template&id=8fdc7fca&scoped=true"
import script from "./TransformQueue.vue?vue&type=script&lang=js"
export * from "./TransformQueue.vue?vue&type=script&lang=js"
import style0 from "./TransformQueue.vue?vue&type=style&index=0&id=8fdc7fca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdc7fca",
  null
  
)

export default component.exports